<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 系统管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title  }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="100px">
          <el-row>
            <el-col :span="5">
              <el-form-item label="出库单号" prop="outBillCode">
                <el-input v-model.number="searchform.outBillCode" placeholder="出库单号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="经销商编码" prop="dealerCode">
                <el-input v-model.number="searchform.dealerCode" placeholder="经销商编码" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="经销商名称" prop="dealerName">
                <el-input v-model.number="searchform.dealerName" placeholder="经销商名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" >查询
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title  }}</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCode" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="经销商名称" min-width="120" show-overflow-tooltip />
            <el-table-column prop="dealerCode" label="经销商编码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="fromWarehouse" label="发货仓库" min-width="120" show-overflow-tooltip />
            <el-table-column prop="fromWarehouseCode" label="发货仓库编码" min-width="120" show-overflow-tooltip />
            <el-table-column prop="address" label="经销商地址" min-width="120" show-overflow-tooltip />
            <el-table-column prop="signCity" label="签收地址" min-width="120" show-overflow-tooltip>
            <template slot-scope="props">
              <div>
                {{ props.row.signAddress }}
              </div>
            </template>
          </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="120" show-overflow-tooltip />
            <el-table-column label="操作" min-width="260" fixed="right">
              <template slot-scope="props">
                <el-button type="primary" @click="selectproducts(props.row)" v-permission="['dealersignorderlogs_products']">查看产品</el-button>
                <el-button type="primary" @click="selectorderimgs(props.row)" v-permission="['dealersignorderlogs_photo']">取证图片</el-button>
                  <el-image v-if="props.row.imglist.length" style="width: 40px; height: 40px" :src="props.row.imglist[0]" :preview-src-list="props.row.imglist">
                  </el-image>
              </template>
            </el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
      <el-dialog title="产品列表" :visible.sync="productsdialog" width="70%">
        <el-divider></el-divider>
        <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="productsData" style="width:100%;"
          id="parent">
          <el-table-column prop="outBillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="freightBillCode" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productCode" label="产品编码" min-width="120" show-overflow-tooltip />
          <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip />
          <el-table-column prop="batchNo" label="批次" min-width="120" show-overflow-tooltip />
          <el-table-column prop="receivableQuantity" label="发货数量" min-width="120" show-overflow-tooltip />
          <el-table-column prop="realQuantity" label="签收扫码数量" min-width="120" show-overflow-tooltip />
          <el-table-column prop="officialQuantity" label="人工确认数量" min-width="120" show-overflow-tooltip />
          <el-table-column prop="address" label="送货地址" min-width="120" show-overflow-tooltip />
          <el-table-column prop="produceTime" label="生产时间" min-width="120" show-overflow-tooltip />
          <el-table-column label="操作" min-width="160">
            <template slot-scope="props">
              <el-button type="primary" @click="selectproductcodes(props.row)">查看箱码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br />
      </el-dialog>
      <el-dialog title="码列表" :visible.sync="productcodesdialog" width="60%">
        <el-divider></el-divider>
        <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="productcodesData"
          style="width:100%;" id="parent">
          <el-table-column prop="outbillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="freightBillCode" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>

          <el-table-column prop="dealerCode" label="经销商编码" min-width="120" show-overflow-tooltip />
          <el-table-column prop="qrcode" label="箱码" min-width="120" show-overflow-tooltip />
          <el-table-column prop="createTime" label="扫码时间" min-width="120" show-overflow-tooltip />
        </el-table>
        <br />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { signorderlist, signorderproductslist, signorderproductscodelist, signimageurllist } from "@/api/physical";
import axios from "axios";
export default {

  mounted() {
    this.listLoading = true;
    this.search();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      tableData: [],
      productsData: [],
      productcodesData: [],
      productsdialog: false,
      productcodesdialog: false,
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      searchform: {
        "address": "",
        "cityId": "",
        "dealerCode": "",
        "dealerName": "",
        "districtId": "",
        "freightBillCode": "",
        "fromWarehouse": "",
        "fromWarehouseCode": "",
        "limit": 10,
        "outBillCode": "",
        // "outType": 0,
        "page": 1,
        "provinceId": "",
        // "sendStatus": 0,
        "status": 2,
      },
      value: true,
    };
  },
  methods: {
    //
    selectorderimgs(row) {
      signimageurllist({
        "batchNo": "",
        "freightBillCode": "",
        "imageUrl": "",
        "limit": 30,
        "outBillCode": row.outBillCode,
        "page": 1,
        "productCode": "",
        "productName": ""
      }).then(response => {
        for (let i = 0; i < response.data.list.length; i++) {
          row.imglist.push(decodeURIComponent(response.data.list[i].imageUrl))

        }
      });
    },
    //请求表格数据  产品表
    selectproducts(row) {
      this.listLoading = true;
      signorderproductslist({
        "batchNo": "",
        "dealerCode": "",
        "dealerName": "",
        "enterpriseCode": "",
        "freightBillCode": "",
        "limit": 499,
        "outBillCode": row.outBillCode,
        "page": 1,
        "productCode": "",
        "productName": "",
      }).then(response => {
        this.productsData = response.data.list;
        this.productsdialog = true;
        this.listLoading = false;
      });
    },
    //请求表格数据 码表
    selectproductcodes(row) {
      this.listLoading = true;
      signorderproductscodelist({
        "batchNo": "",
        "dealerCode": "",
        "dealerName": "",
        "enterpriseCode": "",
        "freightBillCode": "",
        "limit": 499,
        "outbillCode": row.outBillCode,
        "page": 1,
        "productCode": row.productCode,
        "productName": "",
      }).then(response => {
        this.productcodesData = response.data.list;
        this.productcodesdialog = true;
        this.listLoading = false;
      });
    },
    Tabledata(obj) {
      this.listLoading = true;
      signorderlist(obj).then(response => {
        this.packdate(response.data.list);
        this.tableData = response.data.list;

        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData);
      });
    },
    // 拼数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].imglist = [];
      }
    },
    //搜索事件
    search() {
      // this.currentPage = 1;
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.search();
      console.log(page);
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.limit = pageSize;
      this.search();
    }
  }
};
</script>
<style scoped>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>